import { AnalyticsService } from './services/analytics.service';
import { TrackerService } from './services/tracker.service';
import { SelectionsService } from './services/selections.service';
import { BarLoaderComponent } from './bar-loader/bar-loader.component';
import { PipesModule } from './pipes/pipes-module';
import { AngularBaseModule } from './angular-base.module';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { TrackingCodeComponent } from './tracking-code/tracking-code.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { WarningInfoComponent } from './warning-info/warning-info.component';
import { NoteInfoComponent } from './note-info/note-info.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { IconComponent } from './components/icon.component';
import { SaveDialogComponent } from './save-dialog/save-dialog.component';
import { PasswordBoxComponent } from '../authentication/email-confirmation/password-box/password-box.component';
import { PasswordStrengthBarComponent } from '../authentication/email-confirmation/password-box/strength-bar/strength-bar.component';
import { SignInService } from '../authentication/sign-in/sign-in.service';
import { EmailInputComponent } from './email-input/email-input.component';
import { ButtonPrimaryComponent } from './buttons/button-primary.component';
import { ButtonSecondaryComponent } from './buttons/button-secondary.component';
import { LinkComponent } from './link/link.component';
import { DialogWrapperComponent } from './dialog-wrapper/dialog-wrapper.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialDesignModule } from './material-design.module';
import { DirectivesModule } from './directives/directives-module';
import { TranslatedPaginator } from './translated-paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DateService } from 'app/shared/services/date-service';
import { ConsentService } from '../consent/consent.service';
import { NoVisitsComponent } from 'app/dashboard/no-visits/no-visits.component';
import { InviteUserComponent } from 'app/user/invite-user/invite-user.component';
import { UserService } from 'app/user/user.service';
import { DialogWrapperOpenerService } from './dialog-wrapper/dialog-wrapper-opener.service';
import { DialogWrapperEventService } from './dialog-wrapper/dialog-wrapper-event.service';
import { LinkQueryCriteriasBuilder } from '../core/link-query-criteria/link-query-criteria-builder';
import { PeopleService } from 'app/people/people.service';
import { InlineEditTextfieldComponent } from './input/inline-edit-textfield/inline-edit-textfield.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';
import { ValidationService } from './services/validation.service';
import { DeterminateProgressBarComponent } from './progress/determinate-progress-bar/determinate-progress-bar.component';
import { SubscriptionService } from 'app/subscription/subscription.service';
import { AccountService } from 'app/account/account.service';
import { EmailConfirmService } from 'app/authentication/email-confirmation/email-confirm.service';
import { ButtonWithProgressComponent } from './buttons/button-with-progress/button-with-progress.component';
import { SearchInputComponent } from './input/search-input/search-input.component';
import { CreateChipComponent } from '../account-settings/create-chip/create-chip.component';
import { SearchService } from '../search/search.service';
import { SuccessComponent } from './success/success.component';
import { IndeterminateProgressDialogComponent } from './progress/indeterminate-progress-dialog/indeterminate-progress-dialog.component';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { CriteriaDetailsComponent } from '../search/criteria-details/criteria-details.component';
import { FieldAutocompleteComponent } from '../search/criteria-details/field-autocomplete/field-autocomplete.component';
import { FieldRadioComponent } from '../search/criteria-details/field-radio/field-radio.component';
import { CustomfieldDeviceComponent } from '../search/criteria-details/customfield-device/customfield-device.component';
import { VisitsService } from '../visits/visits.service';
import { CodeEditorModule } from './code-editor/code-editor.module';
import { CodeSnippetModule } from './code-editor/code-snippet.module';
import { TbIconComponent } from './icons/tb-icon.component';
import { BrokenPageDialogComponent } from './broken-page-dialog/broken-page-dialog.component';
import { IntegrationsService } from './services/integrations.service';
import { AccountSettingsService } from 'app/account-settings/account-settings.service';
import { DimensionPickerComponent } from './dimension-picker/dimension-picker.component';
import { WidgetPreviewDialogComponent } from './widget-preview-dialog/widget-preview-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateRangeChooserComponent } from './date-range-chooser/date-range-chooser.component';
import { DateRangeMenuComponent } from './date-range-menu/date-range-menu.component';
import { DateRangeChooserService } from './date-range-chooser/date-range-chooser.service';
import { LoadSuggestionsService } from '../search/load-suggestions.service';
import { DomainValidatorDirective } from './custom-validators/domain-validator.directive';
import { AccountColorEditDialogComponent } from 'app/account-settings/account-settings-customization/account-color-edit-dialog/account-color-edit-dialog.component';
import { ContactFieldsComponent } from './../people/contact-fields/contact-fields.component';
import { VariantWidgetComponent } from './variant-widget/variant-widget.component';
import { ResponseListsService } from './services/response-lists.service';
import { AudienceIdentifiedRateChartComponent } from 'app/audience/components/audiences/analytics/audience-identified-rate-chart/audience-identified-rate-chart.component';
import { ChartLegendsComponent } from './chart-legends/chart-legends.component';
import { MegaMenuComponent } from './../layout/mega-menu/mega-menu.component';
import { ThemeToggleComponent } from './../layout/theme-toggle/theme-toggle.component';
import { ExplainerDialogComponent } from './explainer-dialog/explainer-dialog.component';
import { VerifyUserMessageComponent } from '../layout/verify-user-message/verify-user-message.component';
import { SnackComponent } from './snack/snack.component';
import { ZeroViewComponent } from '../dashboard/zero-view/zero-view.component';
import { VerifyUserComponent } from '../verify-user/verify-user.component';
import { ChunkInputComponent } from './input/chunk-input/chunk-input.component';
import { GAUGEComponent } from './gauge/gauge.component';
import { AccountSettingsUsageComponent } from 'app/account-settings/components/account-settings-upgrade-plan/usage/account-settings-usage.component';
import { CampaignService } from './services/campaign.service';
import { TemplateBreadcrumbBarComponent } from './template-breadcrumb-bar/template-breadcrumb-bar.component';
import { CampaignBreadcrumbBarComponent } from './campaign-breadcrumb-bar/campaign-breadcrumb-bar.component';
import { DynamicFieldComponent } from 'app/automations/edit-automation/dynamic-field/dynamic-field.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SkeletonLoaderComponent } from './skeleton-loader/skeleton-loader.component';
import { ChartSeriesLegendComponent } from './chart-series-legend/chart-series-legend.component';
import { ChartOverlayComponent } from './chart-overlay/chart-overlay.component';
import { InfoTooltipComponent } from './info-tooltip/info-tooltip.component';
import { AccountSelectorComponent } from './account-selector/account-selector.component';
import { ActionAutomationComponent } from 'app/flyout/action-automation/action-automation.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { TumbnailBrowserComponent } from './tumbnail-browser/tumbnail-browser.component';
import { ZapierEmbedComponent } from '../automations/zapier-embed/zapier-embed.component';
import { PortalModule } from '@angular/cdk/portal';
import { DeviceButtonsComponent } from './device-buttons/device-buttons.component';
import { SiteIdCopyableComponent } from './site-id-copyable/site-id-copyable.component';
import { FrequencySelectorComponent } from './components/frequency-selector/frequency-selector.component';
import { TimeframeSelectorComponent } from './components/timeframe-selector/timeframe-selector.component';
import { CampaignTemplatesService } from 'app/campaign/templates/campaign-templates.service';
import { ColorPickerModule } from './color-picker/color-picker.module';
import { AccountUpgradeTagComponent } from 'app/account-upgrade/account-upgrade-tag/account-upgrade-tag.component';
import { AccountUpgradePopupComponent } from 'app/account-upgrade/account-upgrade-popup/account-upgrade-popup.component';
import { AccountSettingsBrandSettingsComponent } from 'app/account-settings/components/account-settings-brand-settings/account-settings-brand-settings.component';
import { BrandSettingsPreviewComponent } from 'app/account-settings/components/account-settings-brand-settings/brand-settings-preview/brand-settings-preview.component';
import { FontMenuComponent } from 'app/account-settings/components/account-settings-brand-settings/font-menu/font-menu.component';
import { MarginPaddingComponent } from 'app/campaign/widget-editor/shared-component/margin-padding/margin-padding.component';
import { AlignmentComponent } from 'app/campaign/widget-editor/shared-component/alignment/alignment.component';
import { ToggleDeviceButtonComponent } from 'app/campaign/widget-editor/shared-component/toggle-device-button/toggle-device-button.component';
import { LinkToBrandVariablesComponent } from 'app/campaign/widget-editor/shared-component/link-to-brand-variables/link-to-brand-variables.component';
import { BrandVariablesComponent } from 'app/account-settings/components/account-settings-brand-settings/brand-variables/brand-variables.component';
import { TopbarComponent } from './topbar/topbar.component';
import { TurnstileComponent } from './turnstile/turnstile.component';
import { CodeInputModule } from './code-input/code-input.module';
import { BrandVariablesBackgroundColorComponent } from 'app/account-settings/components/account-settings-brand-settings/brand-variables/brand-variables-background-color/brand-variables-background-color.component';
import { BeeSurprizedNoteComponent } from './bee-surprized-note/bee-surprized-note.component';
import { MediaLibraryComponent } from './media-library/media-library.component';
import { MediaPickerComponent } from './media-library/media-picker/media-picker.component';
import { MediaLibraryModalComponent } from './media-library/media-library-modal/media-library-modal.component';
import { UploadModalComponent } from './media-library/upload-modal/upload-modal.component';
import { MediaLibraryViewComponent } from './media-library-view/media-library-view.component';
import { BatchCreateCampaignsService } from 'app/campaign/batch-create-campaigns.service';
import { UploadMediaModalComponent } from './media-library/upload-media-modal/upload-media-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MediaLibraryService } from './media-library/media-library.service';
import { BrowserIconComponent } from './components/browser-icon/browser-icon.component';
import { OsIconComponent } from './components/os-icon/os-icon.component';
import { PersonAvatarComponent } from './components/person-avatar/person-avatar.component';
import { ExportIconComponent } from './components/export-icon/export-icon.component';
import { WidgetSelectorMenuComponent } from './components/widget-selector-menu/widget-selector-menu.component';
import { ResponseListSelectorComponent } from './components/response-list-selector/response-list-selector.component';
import { AudienceSelectorComponent } from './components/audience-selector/audience-selector.component';
import { SessionConditionsTriggerComponent } from './components/session-conditions-trigger/session-conditions-trigger.component';
import { TagSelectorComponent } from './tag-selector/tag-selector.component';
import { CountrySelectComponent } from './input/country-select/country-select.component';
import { BrandSettingsViewComponent } from '../assets/brand-settings-view/brand-settings-view.component';
import { PageHeaderComponent } from './page-header/page-header.component';

// Exported modules
const modules = [
  PipesModule,
  DirectivesModule,
  AngularBaseModule,
  MaterialDesignModule,
  TranslateModule,
  CodeEditorModule,
  CodeSnippetModule,
  NgxMatSelectSearchModule,
  NgSelectModule,
  BaseChartDirective,
  PortalModule,
  ColorPickerModule,
  CodeInputModule,
  MatTooltipModule,
];

// Exported components
const components = [
  PageHeaderComponent,
  WidgetSelectorMenuComponent,
  ResponseListSelectorComponent,
  AudienceSelectorComponent,
  SessionConditionsTriggerComponent,
  SplashScreenComponent,
  BarLoaderComponent,
  TrackingCodeComponent,
  StarRatingComponent,
  WarningInfoComponent,
  NoteInfoComponent,
  SectionHeaderComponent,
  DateRangePickerComponent,
  IconComponent,
  SaveDialogComponent,
  PasswordBoxComponent,
  PasswordStrengthBarComponent,
  FrequencySelectorComponent,
  TimeframeSelectorComponent,
  EmailInputComponent,
  ButtonPrimaryComponent,
  ButtonSecondaryComponent,
  LinkComponent,
  NoVisitsComponent,
  InviteUserComponent,
  DialogWrapperComponent,
  InlineEditTextfieldComponent,
  ConfirmationDialogComponent,
  DeterminateProgressBarComponent,
  ButtonWithProgressComponent,
  SearchInputComponent,
  CreateChipComponent,
  SuccessComponent,
  IndeterminateProgressDialogComponent,
  CreateChipComponent,
  FieldRadioComponent,
  CustomfieldDeviceComponent,
  FieldAutocompleteComponent,
  CriteriaDetailsComponent,
  TbIconComponent,
  BrokenPageDialogComponent,
  DimensionPickerComponent,
  AccountColorEditDialogComponent,
  ContactFieldsComponent,
  VariantWidgetComponent,
  AudienceIdentifiedRateChartComponent,
  ChartLegendsComponent,
  MegaMenuComponent,
  ThemeToggleComponent,
  ExplainerDialogComponent,
  VerifyUserMessageComponent,
  SnackComponent,
  ZeroViewComponent,
  VerifyUserComponent,
  ChunkInputComponent,
  GAUGEComponent,
  AccountSettingsUsageComponent,
  TemplateBreadcrumbBarComponent,
  CampaignBreadcrumbBarComponent,
  DynamicFieldComponent,
  SkeletonLoaderComponent,
  ChartSeriesLegendComponent,
  ChartOverlayComponent,
  InfoTooltipComponent,
  ActionAutomationComponent,
  TumbnailBrowserComponent,
  ZapierEmbedComponent,
  DeviceButtonsComponent,
  SiteIdCopyableComponent,
  AccountUpgradeTagComponent,
  AccountUpgradePopupComponent,
  AccountSettingsBrandSettingsComponent,
  BrandSettingsPreviewComponent,
  FontMenuComponent,
  MarginPaddingComponent,
  AlignmentComponent,
  ToggleDeviceButtonComponent,
  BrandVariablesComponent,
  BrandVariablesBackgroundColorComponent,
  LinkToBrandVariablesComponent,
  TopbarComponent,
  TurnstileComponent,
  BeeSurprizedNoteComponent,
  MediaLibraryComponent,
  MediaPickerComponent,
  MediaLibraryModalComponent,
  UploadModalComponent,
  UploadMediaModalComponent,
  MediaLibraryViewComponent,
  BrowserIconComponent,
  OsIconComponent,
  PersonAvatarComponent,
  ExportIconComponent,
  TagSelectorComponent,
  CountrySelectComponent,
  BrandSettingsViewComponent,
  AccountSelectorComponent,
];
// Exported services
const services = [
  AnalyticsService,
  TrackerService,
  DateService,
  SelectionsService,
  LoadSuggestionsService,
  SignInService,
  ConsentService,
  UserService,
  DialogWrapperOpenerService,
  DialogWrapperEventService,
  LinkQueryCriteriasBuilder,
  PeopleService,
  ConfirmationDialogService,
  ValidationService,
  SubscriptionService,
  AccountService,
  AccountSettingsService,
  EmailConfirmService,
  SearchService,
  PendingChangesGuard,
  // Don't re-provide IdentityService here — it's a CoreModule singleton; lazy modules would get duplicate instances.
  VisitsService,
  IntegrationsService,
  DateRangeChooserService,
  ResponseListsService,
  CampaignService,
  CampaignTemplatesService,
  BatchCreateCampaignsService,
  MediaLibraryService,
];

@NgModule({
  imports: [...modules, MatButtonToggleModule],
  exports: [...modules, ...components, DateRangeChooserComponent, DateRangeMenuComponent],
  declarations: [
    ...components,
    WidgetPreviewDialogComponent,
    DateRangeChooserComponent,
    DateRangeMenuComponent,
    DomainValidatorDirective,
  ],
  providers: [
    ...services,
    { provide: MatPaginatorIntl, useClass: TranslatedPaginator },
    provideCharts(withDefaultRegisterables()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
